import { graphql } from "gatsby"
import React from "react"

import { IntersectionObserver } from "@knowit-alma/common/src/components/atoms/IntersectionObserver/IntersectionObserver"
import CarouselTestimonial from "@knowit-alma/common/src/components/organisms/CarouselTestimonial/CarouselTestimonial"

const Testimonials = ({ blockDataTestimonials }) => {
  const { testimonials } = blockDataTestimonials || {}

  const items =
    testimonials?.length > 0
      ? testimonials.map((item, index) => {
          const { quote, quotee } = item
          return {
            html: `<p>${quote}</p>`,
            citation: quotee,
          }
        })
      : null

  return (
    <IntersectionObserver reset={false}>
      <CarouselTestimonial slides={items} />
    </IntersectionObserver>
  )
}

export const query = graphql`
  fragment Testimonials on WpBlockAcfTestimonials {
    __typename
    blockDataTestimonials {
      testimonials {
        quote
        quotee
      }
    }
  }
`
export default Testimonials
